import "./ProfileComponent.css";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";

const ProfileComponent = ({ socket }) => {
  const navigate = useNavigate();

  const [foundData, setFoundData] = useState([]); // Состояние для хранения найденных данных
  const [isParsing, setIsParsing] = useState(false); // Состояние для управления парсингом
  const [progress, setProgress] = useState(0); // Состояние для отслеживания прогресса

  useEffect(() => {
    // Подключаемся к серверу через сокет
    socket.on("new_data", (data) => {
      console.log("Received data:", data);

      // Добавляем новые данные в состояние
      setFoundData((prevData) => {
        const newData = [...prevData, data];

        // Проверяем условие: если количество данных >= 10, останавливаем парсинг
        if (newData.length >= 10) {
          setIsParsing(false); // Останавливаем парсинг
        }

        return newData;
      });

      // Увеличиваем прогресс на основе количества полученных данных
      setProgress((prevProgress) => Math.min(prevProgress + 10, 100)); // Ограничение до 100%
    });

    socket.on("userDiconnect", () => {
      localStorage.removeItem('token');
      window.location.reload();
    });

    // Очищаем соединение при размонтировании компонента
    return () => {
      socket.off("new_data");
    };
  }, [socket]);

  const startParsing = () => {
    if (isParsing) return; // Если парсинг уже запущен, ничего не делаем

    setIsParsing(true);
    setProgress(0); // Сбрасываем прогресс перед началом нового парсинга
    setFoundData([]);

    socket.emit("start_parsing"); // Замените "USER_TELEGRAM_ID" на реальный ID
  };

  return (
    <div className="mainContainer">
      <div className="wrapper">
        <div className="mainParsingContainer">
          <span className="title">PARSER</span>
          <div className="parsingContainer">
            <span className="titleParsing">Parsing</span>
            <div className="progressBarContainer">
              <svg className="progressCircle" viewBox="0 0 36 36">
                {/* Определение фильтра */}
                <defs>
                  <filter id="glow">
                    <feGaussianBlur stdDeviation="1" result="coloredBlur" />
                    <feMerge>
                      <feMergeNode in="coloredBlur" />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                </defs>

                {/* Фоновая обводка */}
                <circle
                  className="circleBackground"
                  cx="18"
                  cy="18"
                  r="16"
                  strokeWidth="2"
                />

                {/* Активная обводка */}
                <circle
                  className="circleProgress"
                  cx="18"
                  cy="18"
                  r="16"
                  strokeWidth="2"
                  style={{
                    strokeDasharray: 101,
                    strokeDashoffset: 100 - progress,
                    filter: "url(#glow)", // Применяем фильтр
                  }}
                />
              </svg>
              {/* Галочка */}
              {progress === 100 && <div className="checkmark"></div>}
            </div>

            <div className="foundContainer">
              <span>Found: {foundData.length} wallets</span>
              <button
                className={`buttonOtp ${isParsing ? "active" : ""}`}
                onClick={startParsing}
                disabled={isParsing} // Отключаем кнопку, если парсинг уже запущен
              >
                {isParsing ? "Parsing..." : "Start parsing"}
              </button>
              <button
                className="buttonOtpInActive"
                onClick={() => navigate("/history")}
              >
                History
              </button>
              <button
                className="buttonOtpInActive"
                onClick={() => navigate("/settings")}
              >
                Settings
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileComponent;
